import {z} from 'zod';

import i18n from '@dms/i18n';

// `auditNumber` is BE-generated and never user-editable, so it is intentionally
// not part of the form. The detail page renders it as a read-only header
// instead of a disabled field.
export const recordAuditMetadataFormSchema = z.object({
  // Auditor is optional: a user with no linked employee can still create an audit (it is only
  // mandatory at sign/close time, enforced by the backend). Matches the nullable BE contract.
  auditorEmployeeId: z.string().nullable(),
  responsiblePersonEmployeeId: z.string().nullable(),
  date: z.date(),
  branchId: z.string().nonempty({message: i18n.t('errors.field_is_required')}),
  participants: z.array(
    z.object({
      employeeId: z.string().nonempty({message: i18n.t('errors.field_is_required')}),
    })
  ),
});

export type RecordAuditMetadataFormValue = z.infer<typeof recordAuditMetadataFormSchema>;
